const EXPLAIN_TITLE_KEYS_MAP: any = {
  day: ['dod', 'sdlw', 'change'],
  week: ['wow', 'swlm', 'change'],
  month: ['mom', 'smly', 'change'],
};

const EXPLAIN_DESC_MAP: any = {
  dod: 'Day on Day',
  sdlw: 'Same Day Last Week',
  wow: 'Week on Week',
  swlm: 'Same Week Last Month',
  mom: 'Month on Month',
  smly: 'Same Month Last Year',
};

/**
 * 默认展示的国家列表
 * 优先级: 印尼、美国、俄罗斯、越南、巴西
 */
const DEFAULT_COUNTRY_CODES = ['id', 'us', 'ru', 'vn', 'br'] as const;

/**
 * 默认图标透明度（用于广告格式等维度）
 */
const DEFAULT_ICON_OPACITY = 0.2;

export {
  EXPLAIN_TITLE_KEYS_MAP,
  EXPLAIN_DESC_MAP,
	DEFAULT_COUNTRY_CODES,
  DEFAULT_ICON_OPACITY,
};